import { render, staticRenderFns } from "./CreateFolderInput.vue?vue&type=template&id=bad292f2"
import script from "./CreateFolderInput.vue?vue&type=script&lang=js"
export * from "./CreateFolderInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports